module.exports = __webpack_public_path__ + "img/circle-caret-left.e9540915.svg";